// Local builds have no gateway to inject the domain header, so main API and
// issue tracking requests send the main API host themselves. Kept dependency
// free so anonymous fetches can import it cheaply.
const developmentDomainHost = () =>
  (process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_SXCL_SERVICES_API_HOST) ||
  null;

export default developmentDomainHost;
